import { EnvironmentMode, } from '@/env/enums/EnvironmentMode';
import { VuetifyThemeVariant, } from 'vuetify/types/services/theme';

import colorsTokens from '@/assets/styles/colorsTokens.module.scss';

export type ThemeOption = {
  dark: Partial<VuetifyThemeVariant>,
  light: Partial<VuetifyThemeVariant>
}

const EnvironmentTheme: Record<EnvironmentMode, ThemeOption> = {
  LENDI: {
    light: {
      primary: colorsTokens['light-primary/base'],
      secondary: colorsTokens['light-brand/secondary'],
      info: colorsTokens['light-primary/base'],
      accent: colorsTokens['light-brand/accent'],
      anchor: colorsTokens['light-core/onCore/highEmphasis'],
      warning: colorsTokens['light-warning/base'],
      error: colorsTokens['light-error/base'],
      success: colorsTokens['light-success/base'],
      surface: colorsTokens['light-core/surface'],
      background: colorsTokens['light-core/background'],
      'primary-text': colorsTokens['light-primary/text'],
    },
    dark: {
      primary: colorsTokens['dark-primary/base'],
      secondary: colorsTokens['dark-brand/secondary'],
      info: colorsTokens['dark-primary/base'],
      accent: colorsTokens['dark-brand/accent'],
      anchor: colorsTokens['dark-core/onCore/highEmphasis'],
      warning: colorsTokens['dark-warning/base'],
      error: colorsTokens['dark-error/base'],
      success: colorsTokens['dark-success/base'],
      surface: colorsTokens['dark-core/surface'],
      background: colorsTokens['dark-core/background'],
      'primary-text': colorsTokens['dark-primary/text'],
    },
  },
  STANDARD: {
    light: {
      primary: '#1ab394',
      secondary: '#676a6c',
      info: '#23c6c8',
      warning: '#f8ac59',
      error: '#fa1c1c',
      accent: '#00a2e8',
      success: '#23cd30',
      anchor: '#2c3e50',
      surface: '#fff',
      background: '#f9fbff',
    },
    dark: {
      primary: '#1ab394',
      secondary: '#676a6c',
      info: '#23c6c8',
      warning: '#f8ac59',
      error: '#fa1c1c',
      accent: '#00a2e8',
      success: '#23cd30',
      anchor: '#f9fbff',
      surface: '#1E1E1E',
      background: '#121212',
    },
  },
};

export default EnvironmentTheme;
